export const style = {
  image: {
    width: 20,
  },
};
